// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = '/vote/2020project/2020cqxqd/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
// 获取话题标签
const getTags = () => {
  return http.get(`${urlPrefix}comment-type-list`);
};
// 获取排行榜数据
const getRankList = () => {
  return http.get(`${urlPrefix}comment-rank-list`);
};
// 获取所有评论
const getCommentsTotal = (page: number) => {
  return http.get(`${urlPrefix}comment-list-time`, {
    params: {
      page,
    },
  });
};
// 获取热门评论
const getCommentsHot = () => {
  return http.get(`${urlPrefix}comment-list-hot`);
};
// 提交评论
interface ISubmitWechat {
  content: string;
  tag_id: string;
  headImg: string;
  nickname: string;
  unionid: string;
  phone: number | string;
  county?: string;
  year?: string;
}
interface ISubmitApp {
  content: string;
  tag_id: string;
  udid: string;
  appkey: string;
  phone: number | string;
  county?: string;
  year?: string;
}
const submitComment = (data: ISubmitWechat | ISubmitApp) => {
  return http.post(`${urlPrefix}comment-save`, qs.stringify(data));
};
// 获取指定标签评论列表
const getCommentsByTag = (page: number, tag: string | number) => {
  return http.get(`${urlPrefix}comment-list-tag`, {
    params: {
      page,
      tag_id: tag,
    },
  });
};
// 获取当前用户留言数据
interface IUserHistoryParam {
  page: number;
  unionid?: string;
}
const getUserHistoryComments = (data: IUserHistoryParam) => {
  const { page, unionid } = data;
  return http.get(`${urlPrefix}comment-user-list`, {
    params: {
      page,
      unionid,
    },
  });
};
// 获取评论数量
const getCommentsCount = (type?: string | number) => {
  return http.get(`${urlPrefix}comment-all-num`, {
    params: {
      type,
    },
  });
};
// 点赞
const vote = (id: string | number) => {
  const data = qs.stringify({
    id,
  });
  return http.post(`${urlPrefix}vote`, data);
};

// 获取新闻列表
const getNewsList = (classid: string | number, page: number) => {
  return http.get(`${urlPrefix}comment-list-news`, {
    params: {
      page,
      classid,
    },
  });
};

export {
  getBaseInfo,
  getTags,
  getRankList,
  getCommentsTotal,
  getCommentsHot,
  submitComment,
  getCommentsByTag,
  getCommentsCount,
  getUserHistoryComments,
  vote,
  getNewsList,
};
